import axios from "axios";
import Echo from "laravel-echo";
import Pusher from "pusher-js";

let instance = null;

/**
 * Echo singleton (Pusher), criado sob demanda. Retorna null quando o Pusher
 * não está configurado no ambiente: quem consome trata como "sem realtime"
 * e segue no polling.
 */
export function getEcho() {
    if (instance !== null) {
        return instance;
    }

    const key = import.meta.env.VITE_PUSHER_APP_KEY;

    if (!key) {
        return null;
    }

    window.Pusher = Pusher;

    instance = new Echo({
        broadcaster: "pusher",
        key,
        cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER ?? "us2",
        forceTLS: true,
        authorizer: (channel) => ({
            authorize: (socketId, callback) => {
                axios
                    .post("/broadcasting/auth", {
                        socket_id: socketId,
                        channel_name: channel.name,
                    })
                    .then(({ data }) => callback(null, data))
                    .catch((error) => callback(error, null));
            },
        }),
    });

    return instance;
}
